import 'bootstrap/dist/css/bootstrap.css';
import classNames from 'classnames';
import React__default, { useState, useEffect } from 'react';
import SelectOption from '../SelectOption/SelectOption.js';
import SelectOptionGroup from '../SelectOptionGroup/SelectOptionGroup.js';
import '../../../styles/forms.css.js';
import './select.css.js';
import { styled } from 'styled-components';

const InputStyled = styled.select `
  box-shadow: none !important;
  outline: none !important;

  &:focus {
    border-color: #8a00e5 !important;
  }
`;
const Select = ({ size = 'medium', disabled = false, width = '100%', selectablePlaceholder = false, children, ...props }) => {
    const [selectedValue, setSelectedValue] = useState(props.defaultValue);
    useEffect(() => {
        setSelectedValue(props.defaultValue);
    }, [props.defaultValue]);
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        if (props.onChange) {
            props.onChange(event);
        }
    };
    const renderLabel = () => {
        if (props.label) {
            return React__default.createElement("label", { htmlFor: props.id }, props.label);
        }
        return null;
    };
    const renderOption = (child) => {
        return React__default.createElement(SelectOption, { ...child.props });
    };
    const renderOptionGroup = (child) => {
        return (React__default.createElement(SelectOptionGroup, { label: child.props.label }, child.props.children));
    };
    const renderChildren = () => {
        return React__default.Children.map(children, child => {
            if (React__default.isValidElement(child)) {
                if (child.type === SelectOption) {
                    return renderOption(child);
                }
                else if (child.type === SelectOptionGroup) {
                    return renderOptionGroup(child);
                }
            }
            return null;
        });
    };
    return (React__default.createElement(React__default.Fragment, null,
        renderLabel(),
        React__default.createElement(InputStyled, { id: props.id, disabled: disabled, style: { width: width }, name: props.id, value: selectedValue, onChange: handleChange, className: classNames('form-select', props.className, {
                'form-select-sm': size === 'small',
                'form-select-lg': size === 'large',
            }) },
            props.placeholder ? (React__default.createElement(SelectOption, { hidden: !selectablePlaceholder, value: "", label: props.placeholder })) : null,
            renderChildren())));
};

export { Select as default };
//# sourceMappingURL=Select.js.map
